import { render, staticRenderFns } from "./JSONEditor.vue?vue&type=template&id=0381eb35&scoped=true&"
import script from "./JSONEditor.vue?vue&type=script&lang=ts&"
export * from "./JSONEditor.vue?vue&type=script&lang=ts&"
import style0 from "./JSONEditor.vue?vue&type=style&index=0&id=0381eb35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381eb35",
  null
  
)

export default component.exports